import { forwardRef, useRef } from 'react';

import { mergeRefs } from '@tg-web/utils';

export interface CustomNotificationInputProps {
  label: string;
  maxValue: number;
  onChange: (value: string) => void;
  value: string;
}

export const CustomNotificationInput = forwardRef<
  HTMLInputElement,
  CustomNotificationInputProps
>(({ label, maxValue, onChange, value }, ref) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (value: string) => {
    if (!/^[0-9]{0,2}$/.test(value) || value.startsWith('0')) {
      return;
    }
    if (value.length <= 2) {
      onChange(Number(value) <= maxValue ? value : `${maxValue}`);
    }
  };

  const handleContainerClick = () => {
    inputRef.current?.focus();
  };

  return (
    <div
      className="typo-header-biggest flex items-baseline"
      onClick={handleContainerClick}
    >
      <input
        className="no-spinners max-w-24 bg-transparent text-[64px] outline-none"
        inputMode="numeric"
        onChange={(event) => handleChange(event.target.value)}
        ref={mergeRefs([inputRef, ref])}
        value={value}
        autoFocus
      />
      <span className="text-tg-section-separator">{label}</span>
    </div>
  );
});
